import type {
  FormattedLimitItems,
  LimitValueType
} from '@library/types/memberResponsibleGaming';
import { Table, TableBody, TableHeader } from '@library/components/table';
import type { LimitType } from '@library/types/members';
import { MemberResponsibleGamingRow } from '@bo-components/members/memberResponsibleGaming';
import { memberRGTableHeaders } from '@bo-utils/members/memberResponsibleGaming';

export interface MemberResponsibleGamingLimitsTableProps {
  memberLimits: FormattedLimitItems;
  limitType: LimitType;
  limitValueType: LimitValueType;
}

export const MemberResponsibleGamingLimitsTable = ({
  memberLimits,
  limitType,
  limitValueType
}: MemberResponsibleGamingLimitsTableProps) => {
  return (
    <Table>
      <div
        className="flex flex-col overflow-x-auto"
        data-testid="members-search-results"
      >
        <TableHeader headers={memberRGTableHeaders} />
        <TableBody>
          {memberLimits.map((memberLimit) => (
            <MemberResponsibleGamingRow
              key={`member-${memberLimit.periodType}-${limitType}-limits`}
              limitValueType={limitValueType}
              memberLimit={memberLimit}
            />
          ))}
        </TableBody>
      </div>
    </Table>
  );
};
